import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { v4 as uuid } from 'uuid';
const NotShittyUploadcareWidget = ({ image, onChangeCallback, onChangeInitiated, crop }) => {
    const id = uuid();
    const starterPackIds = [1259883, 1259884, 1259885, 1259886, 1259887, 9778399, 9778400, 9778401, 9778402, 9778403, 14286086, 14286101, 14286102, 14286116, 14286144, 14301948, 14301949, 14301950, 15144912, 15144913, 15144914, 100075, 100076, 100077, 100111, 100113, 100754, 100755, 100756];
    const isStarterPackValue = (image === null || image === void 0 ? void 0 : image.id) && starterPackIds.includes(parseInt(image === null || image === void 0 ? void 0 : image.id));
    const skipInitialRef = useRef(0);
    const wrapperRef = useRef(null);
    const [didChange, setDidChange] = useState(false);
    const onChange = (file) => {
        const uploadElement = document.getElementById(id);
        if (file && !skipInitialRef.current) {
            setDidChange(true);
            file.done(function (fileInfo) {
                onChangeCallback(fileInfo);
            });
        }
    };
    const onUploadComplete = (info) => {
        const uploadElement = document.getElementById(id);
        skipInitialRef.current = 0;
    };
    // @ts-ignore
    const uploadcare = window.uploadcare;
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        if (!isInitialized && uploadcare) {
            const uploadElement = document.getElementById(id);
            // @ts-ignore
            const uploader = uploadcare.SingleWidget(uploadElement);
            uploader.onChange(onChange);
            uploader.onUploadComplete(onUploadComplete);
            uploader.onDialogOpen((dialog) => {
                dialog.done(() => {
                    if (onChangeInitiated) {
                        onChangeInitiated();
                    }
                });
            });
            uploadcare.tabsCss.addStyle(`a.welcome-button, a.welcome-button:hover, a.welcome_button:focus{
                background-color: #ff877b !important;
                border-color: #ff877b;
                outline:none;
                border-radius: 0;
                box-shadow:none;
                transition: none;
            }`);
            if ((image === null || image === void 0 ? void 0 : image.cdnPath) && !isStarterPackValue) {
                skipInitialRef.current = 1;
                //@ts-ignore
                let uncroppedValue = image === null || image === void 0 ? void 0 : image.cdnPath;
                if (uncroppedValue.includes("ucarecdn"))
                    uncroppedValue = uncroppedValue.split("-/")[0];
                uploader.value(uploadcare.fileFrom('url', uncroppedValue));
            }
            setIsInitialized(true);
        }
    }, [uploadcare]);
    useEffect(() => {
        setDidChange(false);
    }, [image === null || image === void 0 ? void 0 : image.cdnPath]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: id + "-wrapper", className: "hidden", ref: wrapperRef, children: _jsx("input", { type: "hidden", id: id, role: "uploadcare-uploader", "data-crop": crop, "data-images-only": "1", "data-input-accept-types": "image/*" }) }), _jsx("a", { className: " text-wfGray-800 hover:border-b-0", onClick: () => {
                    const link = wrapperRef.current.querySelector(".uploadcare--link, .uploadcare--widget__button");
                    if (link) {
                        link.click();
                    }
                }, children: (didChange ? "Uploading..." : (((image === null || image === void 0 ? void 0 : image.cdnPath) && !isStarterPackValue) ? "Change image" : "Choose image")) })] }));
};
export default NotShittyUploadcareWidget;
